// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  RadioGroup,
  Button
} from '../'


export const EmployerAccountSwitcher = ({ currentEmployerId, buttonText, onSelectionClick, onClick, switchOnSelect, className, optionsClassName, buttonDisabled, showGroupAccountAsOption, style }) => {
  const accessibleEmployerAccounts = JSON.parse(localStorage.getItem('accessibleEmployerAccounts'))

  if (accessibleEmployerAccounts.length < 2) {
    return null
  }

  let options = showGroupAccountAsOption
    ? accessibleEmployerAccounts.map(account => (
        {
          label: Object.values(account)[0] === 'group'
            ? <EmployerGroupName employerGroupId={Object.keys(account)[0]} />
            : Object.values(account)[0],
          value: Object.keys(account)[0]
        }
      ))
    : accessibleEmployerAccounts
        .filter(account => Object.values(account)[0] !== 'group')
        .map(account => (
            {
              label: Object.values(account)[0],
              value: Object.keys(account)[0]
            }
          ))

  return (
    <div className={className} style={style}>
      <RadioGroup
        id='employerChoice'
        options={options}
        value={currentEmployerId}
        onClick={onSelectionClick}  // if 'switchOnSelect' is specified as true, 'onSelectionClick' needs to basically contain what would otherwise be called by 'onClick'
        optionsLabelClassName={optionsClassName}
      />
      {!switchOnSelect &&
        <div>
          <Button
            type='brand'
            disabled={buttonDisabled || currentEmployerId === null}
            onClick={onClick}
            className='slds-m-top_medium'>
            {buttonText}
          </Button>
        </div>
      }
    </div>
  )
}

EmployerAccountSwitcher.propTypes = {
  currentEmployerId: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  onSelectionClick: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  switchOnSelect: PropTypes.bool,
  className: PropTypes.string,
  optionsClassName: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  showGroupAccountAsOption: PropTypes.bool,
  style: PropTypes.object
}

EmployerAccountSwitcher.defaultProps = {
  buttonText: 'Log into selected employer account',
  buttonDisabled: false,
  showGroupAccountAsOption: true,
  className: ''
}


const EmployerGroupName = ({ employerGroupId }) => (
  <Query
    query={gql`
      query($id: ID!) {
        employergroup(id: $id) {
          id
          friendlyName
        }
      }
    `}
    variables={{ id: employerGroupId }}>
    {({ loading, error, data }) => {
      if (loading || error) {
        return null
      }

      return `${data.employergroup.friendlyName} (group)`
    }}
  </Query>
)



// WEBPACK FOOTER //
// ./src/components/employer-account-switcher/index.js